import React from "react";
import { motion } from "framer-motion";
import screen1 from "../assets/mockup/screen1.png";

export default function Hero() {
  return (
    <section>
      <div className="container" style={{ textAlign: "center" }}>
        <motion.h1 
          initial={{ opacity: 0, y: -20 }} 
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Transformez votre corps. Suivez vos progrès.
        </motion.h1>

        <p style={{ opacity: 0.7 }}>
          GoalFit vous aide à rester constant, motivé et maître de votre parcours fitness.
        </p>

        <motion.img 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          src={screen1}
          style={{ width: "260px", marginTop: 20, borderRadius: 20 }}
          alt="Interface GoalFit"
        />
      </div>
    </section>
  );
}
